import { Stack } from '@mantine/core'
import React, { Dispatch, SetStateAction } from 'react'

import { Attribute } from '../../../Templates/utils'
import SchemaReader from '../SchemaReader'

const AttributeSettings: React.FC<{
  values: Attribute
  properties: any
  setProperties: Dispatch<SetStateAction<{ [key: string]: any }>>
}> = ({ values, properties, setProperties }) => (
  <Stack style={{ gap: '10px' }}>
    {Object.entries(values).map(([key, value]) => (
      <SchemaReader
        key={key}
        keyName={key}
        schema={value}
        properties={properties}
        setProperties={setProperties}
      />
    ))}
  </Stack>
)

export default AttributeSettings
